import PropTypes from 'prop-types';

const dataRenderMapping: TokenDataMappingItem[] = [
  {
    key: 'tokenizedTerm',
    label: 'Token',
  },
  {
    key: 'postag',
    label: 'Postag',
  },
  {
    key: 'styleColor',
    label: 'StyleColor',
  },
  {
    key: 'startCharPosition',
    label: 'StartCharPosition',
  },
  {
    key: 'endCharPosition',
    label: 'EndCharPosition',
  },
];

export default function TokenInfoTable({ token }: { token: TokenItem }) {
  return (
    <ol>
      {dataRenderMapping.map((data, idx) => {
        return (
          <li
            key={`${data.key}_${idx}`}
            className='tw-flex tw-justify-between tw-px-4 tw-py-1'
          >
            <div className='eds-type--subtitle-2'>{data.label}:</div>
            <div className='eds-type--body-2'>{String(token[data.key])}</div>
          </li>
        );
      })}
    </ol>
  );
}

TokenInfoTable.propTypes = {
  token: PropTypes.shape({
    name: PropTypes.string,
    offe: PropTypes.number,
    natureStr: PropTypes.string,
    synonyms: PropTypes.string,
  }),
};
